export default {"src":"/_next/static/media/ryo.4bb659d0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};